import React from 'react';

const Goal = () => {
  return (
    <section className="goal-section" id="goal">
      <div className="container">
        <div className="goal-content">
          <div className="goal-icon-wrapper">
            <div className="goal-icon">🌟</div>
          </div>
          <div className="goal-text">
            <h2 className="goal-title">Our Goal</h2>
            <p className="goal-description">
              To support survivors of violence by providing free counseling, emotional support, and community education that promotes healing, dignity, and resilience.
            </p>
            <div className="goal-quote">
              <p className="quote-text">We believe healing is not a luxury. It is a right.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Goal;
